var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mx-auto h-full", attrs: { id: "mainSchContainer" } },
    [
      _c("div", { staticClass: "title" }, [
        _c("div", [
          _c("div", { staticClass: "column-icon" }, [
            _vm.isCollapsed
              ? _c(
                  "div",
                  { on: { click: _vm.collapseAll } },
                  [_c("ExpandFilled")],
                  1
                )
              : _c(
                  "div",
                  { on: { click: _vm.collapseAll } },
                  [_c("CollapsedFilled")],
                  1
                ),
          ]),
          _c("span", { staticClass: "type" }, [
            _vm._v(" " + _vm._s(_vm.schedularType)),
          ]),
        ]),
      ]),
      _c(
        "bryntum-scheduler",
        _vm._b(
          { ref: "scheduler", attrs: { scheduleContextMenuFeature: false } },
          "bryntum-scheduler",
          _vm.getSchedulerConfig,
          false
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }